/**
 * DEPRECATED use the generated type from codegen
 */
export enum SQLOrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SearchableItemTypesEnum {
  campaigns = 'campaigns',
  topics = 'topics',
  pathways = 'pathways',
  events = 'events',
  workspaces = 'workspaces',
  certifications = 'certifications',
  surveys = 'surveys',
  groups = 'groups'
}

export enum UserStateResponseEnum {
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  NOT_VERIFIED_NO_PASSWORD = 'NOT_VERIFIED_NO_PASSWORD',
  NOT_VERIFIED_REQUEST_VERIFICATION = 'NOT_VERIFIED_REQUEST_VERIFICATION',
  NOT_FOUND = 'NOT_FOUND',
  NOT_ACTIVE = 'NOT_ACTIVE',
  FORBIDDEN = 'FORBIDDEN'
}

export enum TimeUnitEnum {
  MONTH = 'month',
  WEEK = 'week',
  DAY = 'day'
}
